import { css } from 'styled-components';

import { mapControlWidth, mapControlBg } from './constants';

const mapControlIcon = css`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -10px;
  width: 20px;
  height: 1px;
  content: ' ';
  background-color: #17181a;
`;

export const Zoom = css`
  .lt-map-zoom-controls {
    position: absolute;
    z-index: 4;
    top: 10px;
    left: 10px;
    display: flex;
    flex-direction: column;

    &__with-heatmap {
      top: 165px;
    }

    &__button {
      position: relative;
      width: ${mapControlWidth};
      height: 52px;
      background: ${mapControlBg};
      border: 0;

      &:first-child {
        border-top-left-radius: ${mapControlWidth};
        border-top-right-radius: ${mapControlWidth};
      }

      &:last-child {
        border-bottom-right-radius: ${mapControlWidth};
        border-bottom-left-radius: ${mapControlWidth};
      }

      &[disabled] {
        background: none;

        &::before,
        &::after {
          background-color: #919499;
        }
      }
    }

    &__in {
      &::before {
        ${mapControlIcon};
      }

      &::after {
        ${mapControlIcon};

        transform: rotate(90deg);
      }
    }

    &__out {
      &::before {
        ${mapControlIcon};
      }
    }

    &--disabled {
      border-radius: ${mapControlWidth};
      box-shadow: inset 0 0 0 1px #919499;
    }
  }
`;
